// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"7w7or":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxContext", ()=>CheckboxContext);
parcelHelpers.export(exports, "box", ()=>box);
parcelHelpers.export(exports, "iconStyles", ()=>iconStyles);
parcelHelpers.export(exports, "Checkbox", ()=>_Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _react = require("react");
var _dash = require("../ui-icons/Dash");
var _dashDefault = parcelHelpers.interopDefault(_dash);
var _form = require("./Form");
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const CheckboxContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $l = false;
    let $__a = false;
    for (let p of matches){
        if (/^\s*l/.test(p)) $l = true;
        if (/^\s*__a/.test(p)) $__a = true;
    }
    rules += ' _Zd';
    rules += ' jF';
    rules += ' _1d';
    if (!$l) rules += ' l7';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) {
        rules += ' aa_____B';
        rules += ' aj';
    } else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' _Ob';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (!$__a) {
        if (props.isInForm) rules += ' __a-4a7c5l';
    }
    rules += ' __R-yksgrp';
    return rules;
};
const box = function anonymous(props) {
    let rules = " .";
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    if (props.size === "XL") {
        rules += ' lbl';
        rules += ' lk';
    } else if (props.size === "L") {
        rules += ' lb_b';
        rules += ' l_a';
    } else if (props.size === "S") {
        rules += ' lb9';
        rules += ' l8';
    } else {
        rules += ' lbk';
        rules += ' lj';
    }
    if (props.size === "XL") {
        rules += ' kbl';
        rules += ' kk';
    } else if (props.size === "L") {
        rules += ' kb_b';
        rules += ' k_a';
    } else if (props.size === "S") {
        rules += ' kb9';
        rules += ' k8';
    } else {
        rules += ' kbk';
        rules += ' kj';
    }
    rules += ' _vi';
    rules += ' _wi';
    rules += ' _xi';
    rules += ' _yi';
    rules += ' _8-3t1x';
    rules += ' _Zd';
    rules += ' _1c';
    rules += ' _2d';
    rules += ' uc';
    rules += ' vc';
    rules += ' sc';
    rules += ' tc';
    rules += ' __na';
    rules += ' wa';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' _zb';
    if (props.isSelected) {
        if (props.isDisabled) {
            rules += ' ba_____B';
            rules += ' bj';
        } else if (props.isInvalid) {
            rules += ' ba_____C';
            if (props.isPressed) rules += ' bP';
            else if (props.isFocusVisible) rules += ' bP';
            else if (props.isHovered) rules += ' bP';
            else rules += ' bO';
        } else {
            rules += ' ba_____z';
            if (props.isEmphasized) {
                if (props.isPressed) rules += ' bz';
                else if (props.isFocusVisible) rules += ' bz';
                else if (props.isHovered) rules += ' bz';
                else rules += ' by';
            } else {
                if (props.isPressed) rules += ' bo';
                else if (props.isFocusVisible) rules += ' bo';
                else if (props.isHovered) rules += ' bo';
                else rules += ' bn';
            }
        }
    } else rules += ' bd';
    if (props.isSelected) rules += ' ca';
    else if (props.isDisabled) {
        rules += ' ca_____B';
        rules += ' cj';
    } else if (props.isInvalid) {
        rules += ' ca_____C';
        if (props.isPressed) rules += ' cQ';
        else if (props.isFocusVisible) rules += ' cP';
        else if (props.isHovered) rules += ' cP';
        else rules += ' cO';
    } else {
        rules += ' ca_____v';
        if (props.isPressed) rules += ' co';
        else if (props.isFocusVisible) rules += ' co';
        else if (props.isHovered) rules += ' co';
        else rules += ' cn';
    }
    return rules;
};
const iconStyles = " . -rwx0fg_e-y -rwx0fg_e-a_____V";
const iconSize = {
    S: 'XS',
    M: 'S',
    L: 'M',
    XL: 'L'
};
function Checkbox({ children, ...props }, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CheckboxContext);
    let boxRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _utils.useFocusableRef)(ref, inputRef);
    let isInForm = !!(0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let isInCheckboxGroup = !!(0, _react.useContext)((0, _reactAriaComponents.CheckboxGroupStateContext));
    let ctx = (0, _reactAriaComponents.useSlottedContext)(CheckboxContext, props.slot);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Checkbox), {
        ...props,
        ref: domRef,
        inputRef: inputRef,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + wrapper({
                ...renderProps,
                isInForm,
                size: props.size || 'M'
            }, props.styles),
        children: (renderProps)=>{
            let checkbox = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: boxRef,
                style: (0, _pressScale.pressScale)(boxRef)(renderProps),
                className: box({
                    ...renderProps,
                    isSelected: renderProps.isSelected || renderProps.isIndeterminate,
                    size: props.size || 'M',
                    isEmphasized: isInCheckboxGroup ? ctx?.isEmphasized : props.isEmphasized
                }),
                children: [
                    renderProps.isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashDefault.default), {
                        size: iconSize[props.size || 'M'],
                        className: iconStyles
                    }),
                    renderProps.isSelected && !renderProps.isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                        size: iconSize[props.size || 'M'],
                        className: iconStyles
                    })
                ]
            });
            // Only render checkbox without center baseline if no label.
            // This avoids expanding the checkbox height to the font's line height.
            if (!children) return checkbox;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                        children: checkbox
                    }),
                    children
                ]
            });
        }
    });
}
/**
 * Checkboxes allow users to select multiple items from a list of individual items,
 * or to mark one individual item as selected.
 */ let _Checkbox = /*#__PURE__*/ (0, _react.forwardRef)(Checkbox);
try {
    // @ts-ignore
    CheckboxContext.displayName = "CheckboxContext";
    // @ts-ignore
    CheckboxContext.__docgenInfo = {
        "description": "",
        "displayName": "CheckboxContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<CheckboxProps, FocusableRefValue<HTMLLabelElement, HTMLLabelElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Checkbox.tsx#CheckboxContext"] = {
        docgenInfo: CheckboxContext.__docgenInfo,
        name: "CheckboxContext",
        path: "packages/@react-spectrum/s2/src/Checkbox.tsx#CheckboxContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    box.displayName = "box";
    // @ts-ignore
    box.__docgenInfo = {
        "description": "",
        "displayName": "box",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the checkbox is disabled.\n@selector [data-disabled]",
                "name": "isDisabled",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isFocused": {
                "defaultValue": null,
                "description": "Whether the checkbox is focused, either via a mouse or keyboard.\n@selector [data-focused]",
                "name": "isFocused",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isFocusVisible": {
                "defaultValue": null,
                "description": "Whether the checkbox is keyboard focused.\n@selector [data-focus-visible]",
                "name": "isFocusVisible",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isHovered": {
                "defaultValue": null,
                "description": "Whether the checkbox is currently hovered with a mouse.\n@selector [data-hovered]",
                "name": "isHovered",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isIndeterminate": {
                "defaultValue": null,
                "description": "Whether the checkbox is indeterminate.\n@selector [data-indeterminate]",
                "name": "isIndeterminate",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the checkbox invalid.\n@selector [data-invalid]",
                "name": "isInvalid",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isPressed": {
                "defaultValue": null,
                "description": "Whether the checkbox is currently in a pressed state.\n@selector [data-pressed]",
                "name": "isPressed",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the checkbox is read only.\n@selector [data-readonly]",
                "name": "isReadOnly",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether the checkbox is required.\n@selector [data-required]",
                "name": "isRequired",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isSelected": {
                "defaultValue": null,
                "description": "Whether the checkbox is selected.\n@selector [data-selected]",
                "name": "isSelected",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Checkbox should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Checkbox.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Checkbox.tsx#box"] = {
        docgenInfo: box.__docgenInfo,
        name: "box",
        path: "packages/@react-spectrum/s2/src/Checkbox.tsx#box"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Checkbox.displayName = "_Checkbox";
    // @ts-ignore
    _Checkbox.__docgenInfo = {
        "description": "Checkboxes allow users to select multiple items from a list of individual items,\nor to mark one individual item as selected.",
        "displayName": "_Checkbox",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The label for the element.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultSelected": {
                "defaultValue": null,
                "description": "Whether the element should be selected (uncontrolled).",
                "name": "defaultSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inputRef": {
                "defaultValue": null,
                "description": "A ref for the HTML input element.",
                "name": "inputRef",
                "required": false,
                "type": {
                    "name": "RefObject<HTMLInputElement>"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the input is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Checkbox should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isIndeterminate": {
                "defaultValue": null,
                "description": "Indeterminism is presentational only.\nThe indeterminate visual representation remains regardless of user interaction.",
                "name": "isIndeterminate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the input value is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isReadOnly": {
                "defaultValue": null,
                "description": "Whether the input can be selected but not changed by the user.",
                "name": "isReadOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether user input is required on the input before form submission.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isSelected": {
                "defaultValue": null,
                "description": "Whether the element should be selected (controlled).",
                "name": "isSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Checkbox.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validate": {
                "defaultValue": null,
                "description": "A function that returns an error message if a given value is invalid.\nValidation errors are displayed to the user when the form is submitted\nif `validationBehavior=\"native\"`. For realtime validation, use the `isInvalid`\nprop instead.",
                "name": "validate",
                "required": false,
                "type": {
                    "name": "(value: unknown) => true | ValidationError"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen the value is missing or invalid, or mark the field as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The value of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefvalue).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the element's selection state changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "(isSelected: boolean) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLLabelElement, HTMLLabelElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Checkbox.tsx#_Checkbox"] = {
        docgenInfo: _Checkbox.__docgenInfo,
        name: "_Checkbox",
        path: "packages/@react-spectrum/s2/src/Checkbox.tsx#_Checkbox"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"iknok","1":"gZvyk","2":"iDvLA","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./CenterBaseline":"hXatv","../ui-icons/Checkmark":"255By","react":"jEiK2","../ui-icons/Dash":"95EE2","./Form":"gJckc","./pressScale":"6BiUY","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"iknok":[function() {},{}],"gZvyk":[function() {},{}],"iDvLA":[function() {},{}],"255By":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Checkmark);
var _jsxRuntime = require("react/jsx-runtime");
var _s2CheckmarkSize200Svg = require("./S2_CheckmarkSize200.svg");
var _s2CheckmarkSize200SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize200Svg);
var _s2CheckmarkSize100Svg = require("./S2_CheckmarkSize100.svg");
var _s2CheckmarkSize100SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize100Svg);
var _s2CheckmarkSize75Svg = require("./S2_CheckmarkSize75.svg");
var _s2CheckmarkSize75SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize75Svg);
var _s2CheckmarkSize300Svg = require("./S2_CheckmarkSize300.svg");
var _s2CheckmarkSize300SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize300Svg);
var _s2CheckmarkSize50Svg = require("./S2_CheckmarkSize50.svg");
var _s2CheckmarkSize50SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize50Svg);
var _s2CheckmarkSize400Svg = require("./S2_CheckmarkSize400.svg");
var _s2CheckmarkSize400SvgDefault = parcelHelpers.interopDefault(_s2CheckmarkSize400Svg);
function Checkmark(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize100SvgDefault.default), {
                ...otherProps
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize200SvgDefault.default), {
                ...otherProps
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize300SvgDefault.default), {
                ...otherProps
            });
        case 'XXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize400SvgDefault.default), {
                ...otherProps
            });
        case 'XS':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize50SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CheckmarkSize75SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2JzhG","./S2_CheckmarkSize200.svg":"iO5io","./S2_CheckmarkSize100.svg":"kR0XN","./S2_CheckmarkSize75.svg":"7u0t7","./S2_CheckmarkSize300.svg":"hVRt7","./S2_CheckmarkSize50.svg":"jKv8G","./S2_CheckmarkSize400.svg":"kcGk5","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"iO5io":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M4.313 10.98c-.308 0-.602-.137-.8-.375L.648 7.165a1.042 1.042 0 0 1 1.6-1.334L4.29 8.283l5.442-6.93a1.043 1.043 0 0 1 1.64 1.288l-6.24 7.941a1.04 1.04 0 0 1-.804.397l-.015.001Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CheckmarkSize200;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kR0XN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M3.5 9.503c-.3 0-.584-.135-.774-.367l-2.45-3A1 1 0 1 1 1.823 4.87L3.481 6.9 8.161.888A1 1 0 0 1 9.74 2.118l-5.45 7a1 1 0 0 1-.777.385H3.5Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CheckmarkSize100;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"7u0t7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M3.667 9.074a.958.958 0 0 1-.737-.345L.753 6.116a.96.96 0 1 1 1.474-1.228l1.418 1.7 4.112-5.233a.96.96 0 1 1 1.51 1.186L4.422 8.707a.958.958 0 0 1-.741.367h-.014Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CheckmarkSize75;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hVRt7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M5.102 12.517c-.322 0-.627-.143-.833-.391L.989 8.191a1.083 1.083 0 0 1 .139-1.527 1.081 1.081 0 0 1 1.527.139l2.422 2.904 6.243-7.946a1.086 1.086 0 0 1 1.707 1.34l-7.072 9c-.203.258-.51.41-.838.416h-.015Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CheckmarkSize300;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"jKv8G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize50 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M3.815 8.69a.923.923 0 0 1-.708-.333L1.216 6.09a.922.922 0 0 1 1.416-1.18l1.162 1.394 3.56-4.532a.92.92 0 1 1 1.45 1.14L4.54 8.336a.924.924 0 0 1-.712.352h-.013Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CheckmarkSize50;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kcGk5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CheckmarkSize400 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M5.864 14.115c-.335 0-.653-.15-.868-.407L1.25 9.21a1.13 1.13 0 1 1 1.736-1.447l2.854 3.424 7.148-9.1a1.13 1.13 0 1 1 1.777 1.396l-8.011 10.2a1.13 1.13 0 0 1-.872.432h-.017Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CheckmarkSize400;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"95EE2":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Dash);
var _jsxRuntime = require("react/jsx-runtime");
var _s2DashSize200Svg = require("./S2_DashSize200.svg");
var _s2DashSize200SvgDefault = parcelHelpers.interopDefault(_s2DashSize200Svg);
var _s2DashSize100Svg = require("./S2_DashSize100.svg");
var _s2DashSize100SvgDefault = parcelHelpers.interopDefault(_s2DashSize100Svg);
var _s2DashSize75Svg = require("./S2_DashSize75.svg");
var _s2DashSize75SvgDefault = parcelHelpers.interopDefault(_s2DashSize75Svg);
var _s2DashSize300Svg = require("./S2_DashSize300.svg");
var _s2DashSize300SvgDefault = parcelHelpers.interopDefault(_s2DashSize300Svg);
var _s2DashSize50Svg = require("./S2_DashSize50.svg");
var _s2DashSize50SvgDefault = parcelHelpers.interopDefault(_s2DashSize50Svg);
function Dash(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize100SvgDefault.default), {
                ...otherProps
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize200SvgDefault.default), {
                ...otherProps
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize300SvgDefault.default), {
                ...otherProps
            });
        case 'XS':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize50SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2DashSize75SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2JzhG","./S2_DashSize200.svg":"fGrZX","./S2_DashSize100.svg":"3Gvtj","./S2_DashSize75.svg":"gy364","./S2_DashSize300.svg":"kLhbp","./S2_DashSize50.svg":"i7jX7","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"fGrZX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M10.021 7.041H1.98a1.04 1.04 0 1 1 0-2.082h8.042a1.04 1.04 0 1 1 0 2.082Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2DashSize200;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"3Gvtj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M8.5 6h-7a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2DashSize100;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"gy364":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M6.99 4.96H1.01a.96.96 0 1 1 0-1.92h5.98a.96.96 0 1 1 0 1.92Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2DashSize75;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kLhbp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M10.61 7.085H1.39a1.084 1.084 0 1 1 0-2.17h9.22a1.084 1.084 0 1 1 0 2.17Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2DashSize300;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"i7jX7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2DashSize50 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M6.634 4.922H1.366a.922.922 0 0 1 0-1.844h5.268a.922.922 0 0 1 0 1.844Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2DashSize50;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=Illustrations.91da0d26.js.map
